import { PERMITE_INTEGRACAO_FICTICIA } from "../config/ambiente";
/**
 * Service Logistica (Fase 11 — ADR-0026).
 *
 * Cobre Veiculos, Motoristas, Equipes, Cargas, OrdensEntrega, OrdensInstalacao.
 */

const PREFIXO_VEICULO = "/api/veiculos";
const PREFIXO_MOTORISTA = "/api/motoristas";
const PREFIXO_EQUIPE = "/api/equipes-instalacao";
const PREFIXO_CARGA = "/api/cargas";
const PREFIXO_OE = "/api/ordens-entrega";
const PREFIXO_OI = "/api/ordens-instalacao";

// ============================================================
// Veiculos
// ============================================================

export function listarVeiculos(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.tipo) usp.set("tipo", params.tipo);
  if (params.ativo !== undefined) usp.set("ativo", String(params.ativo));
  if (params.busca) usp.set("busca", params.busca);
  const qs = usp.toString();
  return request(`${PREFIXO_VEICULO}${qs ? `?${qs}` : ""}`);
}

export function criarVeiculo(request, dados) {
  return request(PREFIXO_VEICULO, {
    method: "POST", body: JSON.stringify(dados),
  });
}

export function atualizarVeiculo(request, id, dados) {
  return request(`${PREFIXO_VEICULO}/${id}`, {
    method: "PATCH", body: JSON.stringify(dados),
  });
}

export function desativarVeiculo(request, id) {
  return request(`${PREFIXO_VEICULO}/${id}`, { method: "DELETE" });
}

// ============================================================
// Motoristas
// ============================================================

export function listarMotoristas(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.ativo !== undefined) usp.set("ativo", String(params.ativo));
  if (params.busca) usp.set("busca", params.busca);
  const qs = usp.toString();
  return request(`${PREFIXO_MOTORISTA}${qs ? `?${qs}` : ""}`);
}

export function criarMotorista(request, dados) {
  return request(PREFIXO_MOTORISTA, {
    method: "POST", body: JSON.stringify(dados),
  });
}

export function atualizarMotorista(request, id, dados) {
  return request(`${PREFIXO_MOTORISTA}/${id}`, {
    method: "PATCH", body: JSON.stringify(dados),
  });
}

export function desativarMotorista(request, id) {
  return request(`${PREFIXO_MOTORISTA}/${id}`, { method: "DELETE" });
}

// ============================================================
// Equipes de instalacao
// ============================================================

export function listarEquipes(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.ativo !== undefined) usp.set("ativo", String(params.ativo));
  if (params.busca) usp.set("busca", params.busca);
  const qs = usp.toString();
  return request(`${PREFIXO_EQUIPE}${qs ? `?${qs}` : ""}`);
}

export function criarEquipe(request, dados) {
  return request(PREFIXO_EQUIPE, {
    method: "POST", body: JSON.stringify(dados),
  });
}

export function atualizarEquipe(request, id, dados) {
  return request(`${PREFIXO_EQUIPE}/${id}`, {
    method: "PATCH", body: JSON.stringify(dados),
  });
}

export function desativarEquipe(request, id) {
  return request(`${PREFIXO_EQUIPE}/${id}`, { method: "DELETE" });
}

// ============================================================
// Cargas
// ============================================================

export function listarCargas(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.situacao) usp.set("situacao", params.situacao);
  if (params.data) usp.set("data", params.data);
  if (params.motorista) usp.set("motorista", params.motorista);
  const qs = usp.toString();
  return request(`${PREFIXO_CARGA}${qs ? `?${qs}` : ""}`);
}

export function obterCarga(request, id) {
  return request(`${PREFIXO_CARGA}/${id}`);
}

export function criarCarga(request, dados) {
  return request(PREFIXO_CARGA, {
    method: "POST", body: JSON.stringify(dados),
  });
}

export function iniciarCarregamento(request, id) {
  return request(`${PREFIXO_CARGA}/${id}/iniciar-carregamento`, {
    method: "POST",
  });
}

export function sairEmRota(request, id, { checklist } = {}) {
  return request(`${PREFIXO_CARGA}/${id}/sair-em-rota`, {
    method: "POST",
    body: JSON.stringify({ checklist: checklist || {} }),
  });
}

export function concluirCarga(request, id) {
  return request(`${PREFIXO_CARGA}/${id}/concluir`, { method: "POST" });
}

export function cancelarCarga(request, id, { motivo }) {
  return request(`${PREFIXO_CARGA}/${id}/cancelar`, {
    method: "POST",
    body: JSON.stringify({ motivo }),
  });
}

// B8 (ADR-0038): otimiza a ordem de visita das entregas da carga.
// Body opcional: {origem_endereco, provider}. Sem provider -> mock.
// Resposta = carga com `rota_otimizada` populada.
export function otimizarRota(request, id, { origem_endereco = "", provider } = {}) {
  const body = {};
  if (origem_endereco) body.origem_endereco = origem_endereco;
  if (provider) body.provider = provider;
  return request(`${PREFIXO_CARGA}/${id}/otimizar-rota`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// ============================================================
// Ordens de Entrega
// ============================================================

export function listarOes(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.situacao) usp.set("situacao", params.situacao);
  if (params.pedido) usp.set("pedido", params.pedido);
  if (params.carga) usp.set("carga", params.carga);
  if (params.semCarga) usp.set("sem_carga", "true");
  const qs = usp.toString();
  return request(`${PREFIXO_OE}${qs ? `?${qs}` : ""}`);
}

export function obterOe(request, id) {
  return request(`${PREFIXO_OE}/${id}`);
}

export function criarOe(request, dados) {
  return request(PREFIXO_OE, {
    method: "POST", body: JSON.stringify(dados),
  });
}

export function carregarOe(request, id, { carga_id } = {}) {
  return request(`${PREFIXO_OE}/${id}/carregar`, {
    method: "POST",
    body: JSON.stringify({ carga_id: carga_id || undefined }),
  });
}

export function registrarEntrega(request, id) {
  return request(`${PREFIXO_OE}/${id}/registrar-entrega`, {
    method: "POST",
  });
}

export function registrarNaoEntrega(request, id, { motivo }) {
  return request(`${PREFIXO_OE}/${id}/registrar-nao-entrega`, {
    method: "POST",
    body: JSON.stringify({ motivo }),
  });
}

/**
 * Link publico da assinatura, sob demanda.
 *
 * Security Sprint 2 (A12): `assinatura_token` NAO vem mais no detalhe da OE
 * — quem lia o campo ficava sem link nenhum. Esta action devolve
 * `{token, url, expira_em}`, exige `logistica:entregar` e audita
 * `entrega_link_assinatura_copiado`. 400 quando a OE nao esta ENTREGUE, ja
 * foi assinada ou o token expirou.
 */
export function copiarLinkAssinaturaOe(request, id) {
  return request(`${PREFIXO_OE}/${id}/copiar-link-assinatura`, { method: "POST" });
}

/**
 * CRM-38: confirma a assinatura de quem NAO estava entre os autorizados do
 * cliente. Permissao `logistica:planejar`, body opcional `{observacao}` (ate
 * 300 caracteres). Idempotente; devolve o detalhe da OE e tira o item de
 * Minhas Pendencias. 400 quando a entrega nao tem divergencia a conferir.
 */
export function conferirAssinaturaOe(request, id, { observacao = "" } = {}) {
  return request(`${PREFIXO_OE}/${id}/conferir-assinatura`, {
    method: "POST",
    body: JSON.stringify(observacao ? { observacao } : {}),
  });
}

// ============================================================
// Ordens de Instalacao
// ============================================================

export function listarOis(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.situacao) usp.set("situacao", params.situacao);
  if (params.data) usp.set("data", params.data);
  if (params.equipe) usp.set("equipe", params.equipe);
  if (params.pedido) usp.set("pedido", params.pedido);
  const qs = usp.toString();
  return request(`${PREFIXO_OI}${qs ? `?${qs}` : ""}`);
}

export function obterOi(request, id) {
  return request(`${PREFIXO_OI}/${id}`);
}

export function criarOi(request, dados) {
  return request(PREFIXO_OI, {
    method: "POST", body: JSON.stringify(dados),
  });
}

export function iniciarOi(request, id) {
  return request(`${PREFIXO_OI}/${id}/iniciar`, { method: "POST" });
}

export function concluirOi(request, id, { observacao = "" } = {}) {
  return request(`${PREFIXO_OI}/${id}/concluir`, {
    method: "POST",
    body: JSON.stringify({ observacao }),
  });
}

export function reagendarOi(request, id, { motivo }) {
  return request(`${PREFIXO_OI}/${id}/reagendar`, {
    method: "POST",
    body: JSON.stringify({ motivo }),
  });
}

export function cancelarOi(request, id, { motivo }) {
  return request(`${PREFIXO_OI}/${id}/cancelar`, {
    method: "POST",
    body: JSON.stringify({ motivo }),
  });
}

// ============================================================
// Labels e tones (UI)
// ============================================================

export const SITUACAO_CARGA_LABELS = {
  PLANEJADA: "Planejada",
  CARREGANDO: "Carregando",
  EM_ROTA: "Em rota",
  CONCLUIDA: "Concluida",
  CANCELADA: "Cancelada",
};

export const SITUACAO_CARGA_TONES = {
  PLANEJADA: "neutral",
  CARREGANDO: "info",
  EM_ROTA: "warning",
  CONCLUIDA: "success",
  CANCELADA: "neutral",
};

export const SITUACAO_OE_LABELS = {
  PENDENTE: "Pendente",
  CARREGADA: "Carregada",
  ENTREGUE: "Entregue",
  NAO_ENTREGUE: "Não entregue",
};

export const SITUACAO_OE_TONES = {
  PENDENTE: "neutral",
  CARREGADA: "info",
  ENTREGUE: "success",
  NAO_ENTREGUE: "danger",
};

export const SITUACAO_OI_LABELS = {
  AGENDADA: "Agendada",
  EM_EXECUCAO: "Em execucao",
  CONCLUIDA: "Concluida",
  REAGENDADA: "Reagendada",
  CANCELADA: "Cancelada",
};

export const SITUACAO_OI_TONES = {
  AGENDADA: "info",
  EM_EXECUCAO: "warning",
  CONCLUIDA: "success",
  REAGENDADA: "warning",
  CANCELADA: "neutral",
};

export const TIPOS_VEICULO = [
  { value: "VAN", label: "Van" },
  { value: "CAMINHAO_PEQ", label: "Caminhão pequeno (3/4)" },
  { value: "CAMINHAO_MED", label: "Caminhão médio (toco)" },
  { value: "CAMINHAO_GRD", label: "Caminhão grande (truck)" },
  { value: "OUTRO", label: "Outro" },
];

// ============================================================
// ConfiguracaoRoteirizacao (B8 — ADR-0038): provider de rota por tenant
// ============================================================
//
// Por padrao a PLATAFORMA fornece roteirizacao gratis (OpenRouteService) a
// todos os tenants — a marcenaria nao precisa configurar nada. Esta config eh
// um OVERRIDE opcional: usar conta propria (Google premium ou ORS proprio).

const PREFIXO_CONFIG_ROTA = "/api/configuracoes-roteirizacao";

// Providers que aceitam chave propria do tenant (mostram campo de API key).
export const PROVIDERS_ROTA_COM_CHAVE = ["google_maps", "openrouteservice"];

export const PROVIDERS_ROTA = [
  { value: "openrouteservice", label: "OpenRouteService (grátis — padrão da plataforma)" },
  { value: "google_maps", label: "Google Maps (conta própria)" },
  // Estimativa sem mapa é o provedor de teste: só fora de produção.
  ...(PERMITE_INTEGRACAO_FICTICIA ? [{ value: "mock", label: "Estimativa por proximidade (sem mapa real)" }] : []),
];

// Rotulo legivel do provider (usado nos banners de resultado).
export const ROTA_PROVIDER_LABEL = {
  openrouteservice: "OpenRouteService",
  google_maps: "Google Maps",
  mock: "estimativa",
};

export function listarConfigRoteirizacao(request) {
  return request(PREFIXO_CONFIG_ROTA);
}

export function criarConfigRoteirizacao(request, dados) {
  return request(PREFIXO_CONFIG_ROTA, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function atualizarConfigRoteirizacao(request, id, dados) {
  return request(`${PREFIXO_CONFIG_ROTA}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}
